export default __webpack_public_path__ + "static/char-02-4b1e375111accacbf5e025dfc38c9491.gif";